import React from 'react';
import { Link } from 'react-router-dom';
import './FooterBottomBar.css';
import LinkedIn from '../images/svg/linkedin.svg';
import Instagram from '../images/svg/instagram.svg';
import Behance from '../images/svg/behance.svg';
import Clutch from '../images/svg/clutch.svg';

function FooterBottomBar() {
  return (
    <div className='bottom-bar-container'>
      <div className='col-one'>
        <a href="https://www.facebook.com/people/Marketing-V8/61583812598655/" target="_blank" rel="noopener noreferrer">
          <svg width="35" height="35" viewBox="0 0 35 35" xmlns="http://www.w3.org/2000/svg" className='facebook-icon'>

            <g>
              <path d="M29.1703 4.375H5.82969C5.44476 4.37786 5.07641 4.53205 4.80423 4.80423C4.53205 5.07641 4.37786 5.44476 4.375 5.82969V29.1703C4.37786 29.5552 4.53205 29.9235 4.80423 30.1958C5.07641 30.4679 5.44476 30.6221 5.82969 30.625H18.3969V20.475H14.9844V16.5047H18.3969V13.5844C18.3969 10.1937 20.4641 8.34531 23.5047 8.34531C24.5219 8.34531 25.5391 8.34531 26.5562 8.49844V12.0312H24.4672C22.8156 12.0312 22.4984 12.8188 22.4984 13.9672V16.4938H26.4359L25.9219 20.4641H22.4984V30.625H29.1703C29.5552 30.6221 29.9235 30.4679 30.1958 30.1958C30.4679 29.9235 30.6221 29.5552 30.625 29.1703V5.82969C30.6221 5.44476 30.4679 5.07641 30.1958 4.80423C29.9235 4.53205 29.5552 4.37786 29.1703 4.375Z" fill="white" />
            </g>
          </svg>
        </a>
        <img src={LinkedIn} alt='linkedin icon' />
        <img src={Instagram} alt='instagram icon' />
        <img src={Behance} alt='behance icon' />
        <img src={Clutch} alt='clutch icon' />
      </div>
      <div className='col-two'>
        <Link to='/privacy-policy' className='gray-link' id='privacy-policy'>
          Privacy Policy
        </Link>
      </div>
      <div className='col-three'>
        <p>©2026 Marketing V8. All rights reserved.</p>
      </div>
    </div>
  );
}

export default FooterBottomBar;
